/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetAnnouncementsResponseDto } from '../models';
// @ts-ignore
import type { MarkAnnouncementsSeenRequestDto } from '../models';
/**
 * AppAnnouncementsApi - axios parameter creator
 */
export const AppAnnouncementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get user announcements status
         * @param {string} userId 
         * @param {Array<string>} announcementIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppAnnouncements: async (userId: string, announcementIds: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAppAnnouncements', 'userId', userId)
            // verify required parameter 'announcementIds' is not null or undefined
            assertParamExists('getAppAnnouncements', 'announcementIds', announcementIds)
            const localVarPath = `/api/users/{userId}/announcements`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (announcementIds) {
                localVarQueryParameter['announcementIds'] = announcementIds;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark user announcements as seen
         * @param {string} userId 
         * @param {MarkAnnouncementsSeenRequestDto} markAnnouncementsSeenRequestDto Mark announcements as seen request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAnnouncementsSeen: async (userId: string, markAnnouncementsSeenRequestDto: MarkAnnouncementsSeenRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('markAnnouncementsSeen', 'userId', userId)
            // verify required parameter 'markAnnouncementsSeenRequestDto' is not null or undefined
            assertParamExists('markAnnouncementsSeen', 'markAnnouncementsSeenRequestDto', markAnnouncementsSeenRequestDto)
            const localVarPath = `/api/users/{userId}/announcements`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markAnnouncementsSeenRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppAnnouncementsApi - functional programming interface
 */
export const AppAnnouncementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppAnnouncementsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get user announcements status
         * @param {string} userId 
         * @param {Array<string>} announcementIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppAnnouncements(userId: string, announcementIds: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAnnouncementsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppAnnouncements(userId, announcementIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppAnnouncementsApi.getAppAnnouncements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark user announcements as seen
         * @param {string} userId 
         * @param {MarkAnnouncementsSeenRequestDto} markAnnouncementsSeenRequestDto Mark announcements as seen request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAnnouncementsSeen(userId: string, markAnnouncementsSeenRequestDto: MarkAnnouncementsSeenRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAnnouncementsSeen(userId, markAnnouncementsSeenRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppAnnouncementsApi.markAnnouncementsSeen']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AppAnnouncementsApi - factory interface
 */
export const AppAnnouncementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppAnnouncementsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get user announcements status
         * @param {string} userId 
         * @param {Array<string>} announcementIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppAnnouncements(userId: string, announcementIds: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<GetAnnouncementsResponseDto> {
            return localVarFp.getAppAnnouncements(userId, announcementIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark user announcements as seen
         * @param {string} userId 
         * @param {MarkAnnouncementsSeenRequestDto} markAnnouncementsSeenRequestDto Mark announcements as seen request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAnnouncementsSeen(userId: string, markAnnouncementsSeenRequestDto: MarkAnnouncementsSeenRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markAnnouncementsSeen(userId, markAnnouncementsSeenRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppAnnouncementsApi - interface
 */
export interface AppAnnouncementsApiInterface {
    /**
     * 
     * @summary Get user announcements status
     * @param {string} userId 
     * @param {Array<string>} announcementIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAppAnnouncements(userId: string, announcementIds: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<GetAnnouncementsResponseDto>;

    /**
     * 
     * @summary Mark user announcements as seen
     * @param {string} userId 
     * @param {MarkAnnouncementsSeenRequestDto} markAnnouncementsSeenRequestDto Mark announcements as seen request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    markAnnouncementsSeen(userId: string, markAnnouncementsSeenRequestDto: MarkAnnouncementsSeenRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * AppAnnouncementsApi - object-oriented interface
 */
export class AppAnnouncementsApi extends BaseAPI implements AppAnnouncementsApiInterface {
    /**
     * 
     * @summary Get user announcements status
     * @param {string} userId 
     * @param {Array<string>} announcementIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAppAnnouncements(userId: string, announcementIds: Array<string>, options?: RawAxiosRequestConfig) {
        return AppAnnouncementsApiFp(this.configuration).getAppAnnouncements(userId, announcementIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark user announcements as seen
     * @param {string} userId 
     * @param {MarkAnnouncementsSeenRequestDto} markAnnouncementsSeenRequestDto Mark announcements as seen request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markAnnouncementsSeen(userId: string, markAnnouncementsSeenRequestDto: MarkAnnouncementsSeenRequestDto, options?: RawAxiosRequestConfig) {
        return AppAnnouncementsApiFp(this.configuration).markAnnouncementsSeen(userId, markAnnouncementsSeenRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

